import React, { useState, lazy, useEffect } from 'react';
import { MainContent, CommonContent } from '../../css/css';
import ContactList from './components/contactList';
import { useUpdateEffect } from '../../hooks/useUpdateEffect';
import { usePermission } from '../../hooks/usePermission';
import {
  ConversationWrapper,
  ConversationBottom,
  WhiteBackground,
  SearchWrapper,
  DateName,
  TimeClose,
  SearchTime,
} from './conversation-module-ui';
import api from '@/apis/pc/conversation/conversation';
import { Spin, Input, DatePicker } from 'antd';
import { useRef } from 'react';
import ChatLog from '../chat-log/chatLog';
import { BoxHeader, ButtonItem } from './conversation-module-ui';
import Show from '../show/show';
import userApi from '@/apis/pc/user/user'
import CloseIcon from '../../img/close.png';
import * as wwLocal from '@wecom/jssdk'
import _ from 'lodash';
import moment from "moment";
import { connect } from 'react-redux';
import { getMessageSettingsOpen } from "@/actions/messageSettingsOpen";
import styled, { createGlobalStyle } from 'styled-components';
import { scrollToFirstMessage } from '@/pages/conversation/conversation-utils';
import CovSearchUserList from "@/components/conversation/covSearchUserListForGroupOrFriend"; // 人员列表
import CovSearchMessageUserTab from "@/components/conversation/covSearchMessageUserTab"; // 人员tab
import CovSearchMessageFilter from "@/components/conversation/covSearchMessageFilter"; // 消息信息过滤
import WxImg from "@/img/wx-img.png" 
import { isWorkWechat } from "@/utils/utils";
const { RangePicker } = DatePicker;
const { Search } = Input;

const GlobalStyle = createGlobalStyle`
#zmageImage{
  z-index: 1002 !important;
}
#zmageControl {
  background-color: #111 !important;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 1002 !important;
  #zmageControlClose{
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  }
  path{
    fill: #fff;
  }
}
#zmageBackground{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(17, 17, 17, .32) !important;
  z-index: 1001 !important;
}
`;
const LeftPart = styled.div`
  overflow-y: hidden;
  flex: none;
  .ant-spin-nested-loading{
    height: 100%;
    .ant-spin-container{
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
`;
const CenterPart = styled.div`
  overflow-y: hidden;
  width: 304px;
  border-right: 1px solid #E8EBF6;
  height: 100%;
  display: flex;
  flex-direction: column;
  
`;
const ContentBox = styled.div`
  width: 100%;
  overflow: hidden;
  height: auto;
  flex-grow: 1;
  iframe {
    width: 100%;
    height: 100%;
  }
`;
const RightPart = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
const ConversationTitle = styled.div`
  height: 110px;
  display: flex;
  border-bottom: 1px solid #e9e9e9;
  margin: 0 24px;
`;

const ConversationContent = styled.div`
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  position: relative;
`;
const NoPermission = lazy(() =>
  import('@/pages/no-permission/no-permission').then()
); //缺省页

const mapDispatchToProps = { getMessageSettingsOpen };

const mapStateToProps = (state) => {
  const { messageSettingsOpen, enterPriseInfo, messageSettingsOpen: {companyNoExpire, agentConfig} } = state
  return { messageSettingsOpen: messageSettingsOpen.messageSettingsOpen, enterPriseInfo: enterPriseInfo?.enterPriseInfo, companyNoExpire, agentConfig }
}

const Conversation = (props) => {
  const { isGroup, groupId, uid, wxUserid, customerId } = props;
  const initCondition = { pageSize: 50, pageNum: 1, messageType: 1, content: '', startTime: undefined}; // messageType 1 全部 2 文件 3 图片 
  const paramsUpDownRef = useRef({ upPage: 1, downPage: 1, pageType: 1, pageNum: 1, sessionId: '' }); // pageType  1.全部，2.下拉， down 3.向上加载 up
  const [chatSearchCondition, setChatSearchCondition] = useState(initCondition);
  const [sessionList, setSessionList] = useState([])
  const { hasPermission } = usePermission('查看消息存档'); // 权限
  const [currentUser, setCurrentUser] = useState({}); // 当前选中的部门用户
  const [chatType, setChatType] = useState("1") // 消息类型
  const [searchTime, setSearchTime] = useState(undefined) // 消息时间
  const [searchContent, setSearchContent] = useState('') // 消息内容
  const [loading, setLoading] = useState(false);
  const [isInit, setIsInit] = useState(false); // 是否加载完成

 
  const [currentSession, setCurrentSession] = useState({}); // 当前正在操作的会话，决定了聊天记录栏显示的内容
  const currentSessionRef = useRef(null); //当前正在操作的会话 数据
  let currentSessionTimer = useRef(null);

  const paramsRef = useRef({...initCondition, uid: ''}); // 页面请求参数

  const instanceUserRef = useRef(null); // 会话
  const instanceRef = useRef(null); // 绘画内容
  const instanceScrollRef = useRef(null); // 绘画内容-列表
  const instanceChatRef = useRef(null); // 会话
  const listRef = useRef([]); // 消息列表
  const searchMsgRef = useRef(null); // 消息用户列表
  let searchTimer = useRef(null);

  const instanceUpDownRef = useRef(null); // 会话
  const instanceScrollUpDownRef = useRef(null); // 会话内容-列表
  let searchUpDownTimer = useRef(null);
  let searchMessageTimer = useRef(null);

  useEffect(() => {
    if (hasPermission && props?.companyNoExpire.corpId && props?.companyNoExpire.thirdAgentId&& props.agentConfig?.thirdsignature && !isInit) {
      wx?.ready(async () => {
        const wwSDK = window.ww || isWorkWechat() ? null : wwLocal;
        // await getThirdWxConfig({corpId: companyNoExpire?.corpId, thirdAgentId: companyNoExpire?.thirdAgentId});
        await wwSDK.initOpenData();
        //创建“展示组件工厂”对象备用
        const factory = wwSDK.createOpenDataFrameFactory()
        instanceRef.current = factory.createOpenDataFrame({
          el: document.getElementById('conversation-third-box'), // “容器”元素，用于挂载展示组件
          // <view class="no-more">共{{data.total || 0}}条聊天记录</view>
          template: `
          <scroll-view
            scroll-y="{{true}}"
            scroll-with-animation="{{true}}"
            bindscrolltoupper="onScrollUpper"
            class="scroll"
            ref="refName"
            scroll-into-view="{{toView}}"
            bindscroll="onScroll"
          >
            <block wx:if="{{!data.showNone}}">
              <view wx:if="{{!data.nextPage}}" class="no-more">没有更早的消息了</view>
              <view
                wx:for="{{data.dateList}}"
                wx:key="date"
                wx:for-index="idx"
                wx:for-item="dateItem"
                data-index="{{idx}}"
                data-id="{{dateItem.date}}"
              >
                <view class="date-item">
                  {{dateItem.date}}
                </view>
                <view
                  wx:for="{{dateItem.list}}"
                  wx:key="mgsid"
                  data-index="{{index}}"
                  data-id="{{item.mgsid}}"
                  id="{{item.mgsid}}"
                  bindclick="handleClickEvent"
                >
                  <view
                    id="{{item.mgsid}}"
                    class="log-people {{item.fromWxUserId === data.currentUserOpenId ? 'log-people-right': 'log-people-left'}}"
                  >
                    <ww-open-data wx:if="{{item.sendType == 1}}" type="userAvatar" openid="{{item.fromWxUserId}}"  class="user-avatar"/>
                    <ww-open-data wx:elif="{{item.roomid}}" type="externalUserAvatar" openid="{{item.roomid}}/{{item.fromWxUserId}}"  class="user-avatar"/>
                    <ww-open-data wx:else type="externalUserAvatar" openid="{{item.fromWxUserId}}"  class="user-avatar"/>
                    <view class="log-people-content">
                      <view class="log-people-info {{item.fromWxUserId === data.currentUserOpenId ? 'log-people-info-right': 'log-people-info-left'}}">
                        <ww-open-data wx:if="{{item.sendType == 1}}" type="userName" openid="{{item.fromWxUserId}}"  class="user-name"/>
                        <ww-open-data wx:elif="{{item.roomid}}" type="externalUserName" openid="{{item.roomid}}/{{item.fromWxUserId}}"  class="user-name"/>
                        <ww-open-data wx:else type="externalUserName" openid="{{item.fromWxUserId}}"  class="user-name"/>
                        <view wx:if="{{item.corpName}}" style="color: {{ item.corpName === '@微信' ? '#00B042' : '#FF9200'}}" class="user-label">{{item.corpName}}</view>
                        <view class="user-time">{{item.msgtime}}</view>
                      
                      </view>
                      <view class="{{item.fromWxUserId === data.currentUserOpenId ? 'user-message-right': 'user-message-left'}}">
                        <view class="{{item.fromWxUserId === data.currentUserOpenId ? 'user-message user-message-r': 'user-message'}}">
                          <ww-open-message
                            message-id="{{item.mgsid}}"
                            secret-key="{{item.content}}"
                            open-type="viewMessage"
                            binderror="onOpenMsgError"
                          />
                        </view>
                      </view>
                    </view>
                  </view>
                  
                </view>
              </view>
              
            </block>
          </scroll-view>
          `,
          data: {
            msgs: [],
            dateList: [],
            toView: '',
            showNone: true,
          },
          style: `
          .scroll{
            height: 100%;
            padding: 24px;
            box-sizing: border-box;
          }
            
          .scroll{
            height: 100%;
            box-sizing: border-box;
          }
          .scroll::-webkit-scrollbar {
            width: 4px;
            height: 10px;
          }
          .scroll::-webkit-scrollbar-track {
            border-radius: 2px;
            background-color: #fff;
          }
          .scroll::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #E8EBF6;
          }
          .scroll::-webkit-scrollbar-thumb::hover{
            background: #9A9EBA;
          }
          .scroll::-webkit-scrollbar-corner {
            background: #000000;
          }
          .log-people {
            color: rgb(89, 89, 89);
            font-size: 12px;
            display: flex;
          }
          .log-people-content{
            margin-left: 8px
          }
          .log-people-info{
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          }
          .log-people-info-right {
            flex-direction: row-reverse;
          }
          .log-people-info-left {
          }
          .log-people-right {
            flex-direction: row-reverse;
          }
          .user-avatar{
            width: 40px;
            height: 40px;
            border-radius: 4px;
          }
          .user-name{
            margin: 0px 4px 0;
          }
          .user-label {
            flex:none;
            font-size: 12px;
            margin-right: 4px;
          }
          .user-time{
            display: inline-block;
            font-size: 12px;
            color: rgb(191, 191, 191);
          }
          .user-message{
            margin-bottom: 16px;
            overflow-wrap: break-word;
            word-break: break-all;
          
            display: inline-block;
            margin-top: 8px;
            padding: 16px;
            background:  #F5F8FF;
            border-radius: 8px;
            color: #595959;
          }
          .date-item{
            width: 100%;
            font-weight: 400;
            font-size: 12px;
            color: #9A9EBA;
            line-height: 16px;
            margin-bottom: 16px;
            padding-top: 16px;
            text-align: center;
          }
          .user-message-right{
            display: flex;
            justify-content: flex-end;
            margin-left: 40px;
          }
          .user-message-r{
            background:  #F5F8FF;
          }
          .no-more{
            width: 100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            margin-top: 15px;
            margin-bottom: 10px;
            color: rgb(191, 191, 191);
            font-size: 12px;
          
            ::before{
              background: none !important;
            }
          }
          `,
          methods: {
            onScrollUpper: () => {
              console.log('到顶部', instanceRef.current.data)
              if (instanceRef.current.data.nextPage) {
                loadMore();
              }
            },
            onScroll: (e) => {
            },
            handleClickEvent() {
              // // 响应消息点击事件
            },
            onOpenMsgError(event) {
              console.warn('open message error: ', event);
            },
            setElStyle() {

              
            },
          },
          error: (err) => {
            console.log('error', err)
          },
        })
        if (instanceRef.current) {
          instanceScrollRef.current = await wwSDK.createScrollViewContext(instanceRef.current, 'refName')
          window.instanceScrollRef = instanceScrollRef.current;
        }


        instanceUpDownRef.current = factory.createOpenDataFrame({
          el: document.getElementById('conversation-third-box-time'), // “容器”元素，用于挂载展示组件
          // <view class="no-more">共{{data.total || 0}}条聊天记录</view>
          template: `
          <scroll-view
            scroll-y="{{true}}"
            bindscrolltoupper="onScrollUpper"
            bindscrolltolower="onScrollLower"
            class="scroll"
            ref="refName"
            bindscroll="onScroll"
          >
            <block wx:if="{{!data.showNone}}">
              <view wx:if="{{!data.hasDownPage}}" class="no-more">没有更早的消息了</view>
              <view
                wx:for="{{data.dateList}}"
                wx:key="date"
                wx:for-index="idx"
                wx:for-item="dateItem"
                data-index="{{idx}}"
                data-id="{{dateItem.date}}"
              >
                <view class="date-item">
                  {{dateItem.date}}
                </view>
                <view
                  wx:for="{{dateItem.list}}"
                  wx:key="msgIdQuery"
                  data-index="{{index}}"
                  data-id="{{item.msgIdQuery}}"
                  id="{{item.msgIdQuery}}"
                  bindclick="handleClickEvent"
                >
                  <view
                    id="{{item.mgsid}}"
                    class="log-people {{item.fromWxUserId === data.currentUserOpenId ? 'log-people-right': 'log-people-left'}}"
                  >
                    <ww-open-data wx:if="{{item.sendType == 1}}" type="userAvatar" openid="{{item.fromWxUserId}}"  class="user-avatar"/>
                    <ww-open-data wx:elif="{{item.roomid}}" type="externalUserAvatar" openid="{{item.roomid}}/{{item.fromWxUserId}}"  class="user-avatar"/>
                    <ww-open-data wx:else type="externalUserAvatar" openid="{{item.fromWxUserId}}"  class="user-avatar"/>
                    <view class="log-people-content">
                      <view class="log-people-info {{item.fromWxUserId === data.currentUserOpenId ? 'log-people-info-right': 'log-people-info-left'}}">
                        <ww-open-data wx:if="{{item.sendType == 1}}" type="userName" openid="{{item.fromWxUserId}}"  class="user-name"/>
                        <ww-open-data wx:elif="{{item.roomid}}" type="externalUserName" openid="{{item.roomid}}/{{item.fromWxUserId}}"  class="user-name"/>
                        <ww-open-data wx:else type="externalUserName" openid="{{item.fromWxUserId}}"  class="user-name"/>
                        <view wx:if="{{item.corpName}}" style="color: {{ item.corpName === '@微信' ? '#00B042' : '#FF9200'}}" class="user-label">{{item.corpName}}</view>
                        <view class="user-time">{{item.msgtime}}</view>
                      
                      </view>
                      <view class="{{item.fromWxUserId === data.currentUserOpenId ? 'user-message-right': 'user-message-left'}}">
                        <view class="{{item.fromWxUserId === data.currentUserOpenId ? 'user-message user-message-r': 'user-message'}}">
                          <ww-open-message
                            message-id="{{item.mgsid}}"
                            secret-key="{{item.content}}"
                            open-type="viewMessage"
                            binderror="onOpenMsgError"
                          />
                        </view>
                      </view>
                    </view>
                  </view>
                  
                </view>
              </view>
              
            </block>
          </scroll-view>
          `,
          data: {
            msgs: [],
            dateList: [],
            showNone: true,
            hasDownPage: true,
            hasUpPage: true,
          },
          style: `
          .scroll{
            height: 100%;
            padding: 24px;
            box-sizing: border-box;
          }
            
          .scroll{
            height: 100%;
            box-sizing: border-box;
          }
          .scroll::-webkit-scrollbar {
            width: 4px;
            height: 10px;
          }
          .scroll::-webkit-scrollbar-track {
            border-radius: 2px;
            background-color: #fff;
          }
          .scroll::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #E8EBF6;
          }
          .scroll::-webkit-scrollbar-thumb::hover{
            background: #9A9EBA;
          }
          .scroll::-webkit-scrollbar-corner {
            background: #000000;
          }
          .log-people {
            color: rgb(89, 89, 89);
            font-size: 12px;
            display: flex;
          }
          .log-people-content{
            margin-left: 8px
          }
          .log-people-info{
            display: flex;
            -webkit-box-align: center;
            align-items: center;
          }
          .log-people-info-right {
            flex-direction: row-reverse;
          }
          .log-people-info-left {
          }
          .log-people-right {
            flex-direction: row-reverse;
          }
          .log-people-right .log-people-content{
            margin-left: 0px
            margin-right: 8px
          }
          .user-avatar{
            width: 40px;
            height: 40px;
            border-radius: 4px;
          }
          .user-name{
            margin: 0px 4px 0;
          }
          .user-label {
            flex:none;
            font-size: 12px;
            margin-right: 4px;
          }
          .user-time{
            display: inline-block;
            font-size: 12px;
            color: rgb(191, 191, 191);
          }
          .user-message{
            margin-bottom: 16px;
            overflow-wrap: break-word;
            word-break: break-all;
          
            display: inline-block;
            margin-top: 8px;
            padding: 16px;
            background:  #E9E9E9;
            border-radius: 8px;
            color: #595959;
          }
          .date-item{
            width: 100%;
            font-weight: 400;
            font-size: 12px;
            color: #9A9EBA;
            line-height: 16px;
            margin-bottom: 16px;
            padding-top: 16px;
            text-align: center;
          }
          .user-message-right{
            display: flex;
            justify-content: flex-end;
            margin-left: 40px;
          }
          .user-message-r{
            background: #D9EEFF;
          }
          .no-more{
            width: 100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            margin-top: 15px;
            margin-bottom: 10px;
            color: rgb(191, 191, 191);
            font-size: 12px;
          
            ::before{
              background: none !important;
            }
          }
          `,
          methods: {
            // upPage: 1, downPage: 1
          onScrollUpper: () => {
            console.log('到顶部', instanceUpDownRef.current.data, instanceUpDownRef.current.data.hasDownPage)
            if (!instanceUpDownRef.current.data.hasDownPage) return;
            if (searchUpDownTimer.current) clearTimeout(searchUpDownTimer.current);
            searchUpDownTimer.current = setTimeout(() => {
              clearTimeout(searchUpDownTimer.current);
              searchUpDownTimer.current = null;
              paramsUpDownRef.current.downPage = paramsUpDownRef.current.downPage + 1;
              paramsUpDownRef.current.pageNum = paramsUpDownRef.current.downPage ;
              paramsUpDownRef.current.pageType = 2;
              chatSearchUpDown(false, 'down');
            }, 500)
          },
          onScrollLower: () => {
            console.log('到底部', instanceUpDownRef.current.data, instanceUpDownRef.current.data.hasUpPage)
            if (!instanceUpDownRef.current.data.hasUpPage) return;
            if (searchUpDownTimer.current) clearTimeout(searchUpDownTimer.current);
            searchUpDownTimer.current = setTimeout(() => {
              clearTimeout(searchUpDownTimer.current);
              searchUpDownTimer.current = null;
              paramsUpDownRef.current.upPage = paramsUpDownRef.current.upPage + 1;
              paramsUpDownRef.current.pageNum = paramsUpDownRef.current.upPage ;
              paramsUpDownRef.current.pageType = 3;
              chatSearchUpDown(false, 'up');
            }, 500)
          },
            handleClickEvent() {
              // // 响应消息点击事件
            },
            onOpenMsgError(event) {
              console.warn('open message error: ', event);
            },
            setElStyle() {

              
            },
          },
          error: (err) => {
            console.log('error', err)
          },
        })
        if (instanceUpDownRef.current) {
          instanceScrollUpDownRef.current = await wwSDK.createScrollViewContext(instanceUpDownRef.current, 'refName')
          window.instanceScrollUpDownRef = instanceScrollUpDownRef.current;
        }
        const factoryUser = wwSDK.createOpenDataFrameFactory()
        instanceUserRef.current = factoryUser.createOpenDataFrame({
          el: document.getElementById('conversation-third-user-list'), // “容器”元素，用于挂载展示组件
          template: `
          <scroll-view
            scroll-y="{{true}}"
            scroll-with-animation="{{true}}"
            class="scroll"
            bindscrolltolower="onScrollLower"
          >
            <view
              wx:for="{{data.msgList}}"
              wx:key="sessionId"
              data-index="{{item.sessionId}}"
              data-id="{{item.sessionId}}"
              bindclick="handleClickEvent"
              id="{{item.sessionId}}"
              class="content {{item.sessionId === data.chatId ? 'content-active' : ''}}"
            >
              <view class="user-img">
                <ww-open-data class="user-image" wx:if="{{item.sessionType == 1}}" type="externalUserAvatar" openid="{{item.fromIsCurrentUser ? item.toWxUserId : item.fromWxUserId}}"/>
                <ww-open-data class="user-image" wx:elif="{{item.sessionType == 3}}" type="userAvatar" openid="{{item.fromIsCurrentUser ? item.toWxUserId : item.fromWxUserId}}"/>
                <image class="user-image" wx:else src='${WxImg}' />
              </view>
              <view class="chat-info">
                <view class="contact-list-info">
                  <view class="user-name" wx:if="{{item.extendUserRemark}}">{{item.extendUserRemark}}</view>
                  <view class="user-name" wx:elif="{{item.sessionType == 1}}"><ww-open-data type="externalUserName" openid="{{item.fromIsCurrentUser ? item.toWxUserId : item.fromWxUserId}}"  class="user-name"/></view>
                  <view class="user-name" wx:elif="{{item.sessionType == 3}}"><ww-open-data type="userName" openid="{{item.fromIsCurrentUser ? item.toWxUserId : item.fromWxUserId}}"  class="user-name"/></view>
                  <view class="user-name" wx:else><ww-open-data type="chatName" openid="{{item.roomId}}"  class="user-name"/></view>
                  <view wx:if="{{item.corpName}}" style="color: {{ item.corpName === '@微信' ? '#00B042' : '#FF9200'}}" class="user-label">{{item.corpName}}</view>
                  <view wx:if="{{item.roomId && item.groupDismissed}}" class="com-label">已解散</view>
                  <view wx:if="{{!item.roomId && item.extStatus == 2}}" class="com-label">已流失</view>
                  <view wx:if="{{!item.roomId && item.extStatus == 1}}" class="com-label-del">已删除</view>
                  </view>
  
                <view class="message-line">
                  <view class="message-info">
                    <block wx:if="{{item.scrmMessage.sessionType}}">
                      <ww-open-data wx:if="{{item.scrmMessage.sessionType === 1}}" type="userName" openid="{{item.scrmMessage.fromUser.id}}"  class="user-name"/>
                      <ww-open-data wx:elif="{{item.roomId}}" type="externalUserName" openid="{{item.roomId}}/{{item.scrmMessage.fromUser.id}}"  class="user-name"/>
                      <ww-open-data wx:else type="externalUserName" openid="{{item.scrmMessage.fromUser.id}}"  class="user-name"/>
                      :
                    </block>
                    [{{item.lastMsgtypeStr}}]
                  </view>
                  <view class="message-time">{{item.fromNow}}</view>
                </view>
              </view>
  
            </view>
          </scroll-view>
          `,
          style: `
          .message-box {
            --ww_base_gray_100: #bfbfbf;
            line-height: 16px;
            height: 16px;
            div {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              color: rgb(191, 191, 191);
              .a {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
                color: rgb(191, 191, 191);
              }
            }
          }
          .message-box > div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            color: rgb(191, 191, 191);
          }
          .message-box span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            color: rgb(191, 191, 191);
          }
          .scroll{
            height: 100%;
            box-sizing: border-box;
          }
          .scroll::-webkit-scrollbar {
            width: 4px;
            height: 10px;
          }
          .scroll::-webkit-scrollbar-track {
            border-radius: 2px;
            background-color: #fff;
          }
          .scroll::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #E8EBF6;
          }
          .scroll::-webkit-scrollbar-thumb::hover{
            background: #9A9EBA;
          }
          .scroll::-webkit-scrollbar-corner {
            background: #000000;
          }

          .content{
            padding: 8px 0px 8px 24px;
            overflow: hidden;
            display: flex;
          }
          .content-active{
            background: rgb(255, 242, 234) !important;
          }
          .user-img{
            flex: none;
          }
          .user-image{
            width: 40px;
            height: 40px;
            align-self: center;
            border-radius: 4px;
          }
          .chat-info{
            padding-right: 16px;
            padding-left: 8px;
            overflow: hidden;
            flex: 1;
          }
          .contact-list-info {
            display: flex;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            height: 26px;
            margin-top: -1px;
            -webkit-box-align: center;
            align-items: center;
          }
          .contact-list-info .user-name {
            color: rgb(89, 89, 89);
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            font-size: 14px;
            flex:none;
          }
          .contact-list-info .user-label {
            font-size: 12px;
            margin-left: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
            
          .contact-list-info .com-label {
            border-radius: 4px;
            padding: 0 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #9A9EBA;
            background: #EBECF1;
            line-height: 20px;
            margin-left: 1px;
            flex: none;
          }
          .contact-list-info .com-label-del{
            border-radius: 4px;
            padding: 0 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #F44764;
            background: #FDE3E7;
            line-height: 20px;
            margin-left: 1px;
            flex: none;
          }
          .message-line{
            display: flex;
            -webkit-box-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            align-items: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, "PingFang SC";
            font-weight: 400;
            color: rgb(191, 191, 191);
            width: 100%;
            margin-top: auto;
          }
          .message-line .message-info{
            width: max-content;
            display: flex;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            flex: 1 1 0%;
            font-size: 12px;
            font-family: PingFangSC-Regular, "PingFang SC";
            font-weight: 400;
            color: rgb(191, 191, 191);
          }
          .message-line .message-info .user-name{
            display: block;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: none;
          }
          .message-line .message-info .message-box{
            font-size: 12px;
            font-family: PingFangSC-Regular, "PingFang SC";
            font-weight: 400;
            color: rgb(191, 191, 191);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .message-line .message-time{
            padding-left: 20px;
            width: max-content;
            display: inline-block;
            font-size: 12px;
            font-family: PingFangSC-Regular, "PingFang SC";
            font-weight: 400;
            color: rgb(191, 191, 191);
          }
          `,
          data: {
            msgList: [],
            chatId: '',
          },
          methods: {
            handleClickEvent(e) {
              // // 响应消息点击事件
              const id = e.currentTarget.dataset.id;
              const item = this.data.msgList.find(item => item.sessionId == id);
              currentSessionRef.current.item = item;
              changeSessionOrMessage({ setType: "session", ...item });
            },
            onScrollLower() {
              if (searchTimer.current) clearTimeout(searchTimer.current);
              searchTimer.current = setTimeout(() => {
                clearTimeout(searchTimer.current);
                searchTimer.current = null;
                searchMsgRef.current?.getNextList();
              }, 300)
              
            },
            onOpenMsgError(event) {
              console.warn('open message error: ', event);
            }
          },
          error: (err) => {
            console.log('error', err)
          },
        })

        const factoryChat = wwSDK.createOpenDataFrameFactory()
        instanceChatRef.current = factoryChat.createOpenDataFrame({
          el: document.getElementById('conversation-third-mes-info'), // “容器”元素，用于挂载展示组件
          template: `
            <view class="box">
              <view class="content">
                <view class="user-img">
                  <ww-open-data class="user-image" wx:if="{{data.chatMsg.sessionType == 1}}" type="externalUserAvatar" openid="{{data.chatMsg.fromIsCurrentUser ? data.chatMsg.toWxUserId : data.chatMsg.fromWxUserId}}"/>
                  <ww-open-data class="user-image" wx:elif="{{data.chatMsg.sessionType == 3}}" type="userAvatar" openid="{{data.chatMsg.fromIsCurrentUser ? data.chatMsg.toWxUserId : data.chatMsg.fromWxUserId}}"/>
                  <image class="user-image" wx:elif="{{data.chatMsg.sessionId}}" src='${WxImg}' />
                </view>
                <view class="chat-top">
                  <view class="contact-list-info">
                    <view class="user-name" wx:if="{{data.chatMsg.extendUserRemark}}">{{data.chatMsg.extendUserRemark}}</view>
                    <view class="user-name" wx:elif="{{data.chatMsg.sessionType == 1}}"><ww-open-data type="externalUserName" openid="{{data.chatMsg.fromIsCurrentUser ? data.chatMsg.toWxUserId : data.chatMsg.fromWxUserId}}"  class="user-name"/></view>
                    <view class="user-name" wx:elif="{{data.chatMsg.sessionType == 3}}"><ww-open-data type="userName" openid="{{data.chatMsg.fromIsCurrentUser ? data.chatMsg.toWxUserId : data.chatMsg.fromWxUserId}}"  class="user-name"/></view>
                    <view class="user-name" wx:else><ww-open-data type="chatName" openid="{{data.chatMsg.roomId}}"  class="user-name"/></view>

                    <view wx:if="{{data.chatMsg.corpName}}" style="color: {{ data.chatMsg.corpName === '@微信' ? '#00B042' : '#FF9200'}}" class="user-label">{{data.chatMsg.corpName}}</view>
                    <view wx:if="{{data.chatMsg.roomId && data.chatMsg.groupDismissed}}" class="com-label">已解散</view>
                    <view wx:if="{{!data.chatMsg.roomId && data.chatMsg.extStatus == 2}}" class="com-label">已流失</view>
                    <view wx:if="{{!data.chatMsg.roomId && data.chatMsg.extStatus == 1}}" class="com-label-del">已删除</view>
                  </view>
                  <view class="other">
                    <block wx:if="{{data.chatMsg.roomId}}">
                    </block>
                    
                    <block wx:if="{{data.createdTime}}">
                      <view class="friend-time">
                        <view>
                        {{data.createdTime}}
                        </view>
                        <view class="friend-time-title">
                          成为好友
                        </view>
                      </view>
                    </block>
                    <block wx:if="{{data.chatMsg.roomId}}">
                      <view class="friend-time">
                        <view>
                        群主：
                        </view>
                        <view wx:if="{{data.ownerName}}" class="friend-time-title">
                          {{data.ownerName}}
                        </view>
                        <view wx:else class="friend-time-title">
                          未知
                        </view>
                      </view>
                    </block>
                    
                  </view>
                </view>
              </view>
              <view class="label-box">
                <view wx:for="{{data.labels}}" wx:key="item" class="label-item">{{item}}</view>
              </view>
            </view>
          `,
          style: `
            .box {
              overflow: hidden;
              width: 100%;
              height: 100%;
            }
            .box::-webkit-scrollbar {
              width: 4px;
              height: 10px;
            }
            .box::-webkit-scrollbar-track {
              border-radius: 2px;
              background-color: #fff;
            }
            .box::-webkit-scrollbar-thumb {
              border-radius: 10px;
              background: #E8EBF6;
            }
            .box::-webkit-scrollbar-thumb::hover{
              background: #9A9EBA;
            }
            .box::-webkit-scrollbar-corner {
              background: #000000;
            }
            .label-box{
              margin: 8px 0 16px;
              display: flex;
            }
            .label-box .label-item{
              line-height: 18px;
              background: #FAFAFA;
              border-radius: 4px;
              border: 1px solid #D9D9D9;
              padding: 0 8px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #130928;
              margin-right: 4px;
              margin-bottom: 4px;
              flex-wrap: wrap;
              flex: none;
            }
            .content {
              display: flex;
              padding: 24px 0px 0px;
            }
            .user-img{
              flex: none;
            }
            .user-image{
              width: 42px;
              height: 42px;
              align-self: center;
              border-radius: 4px;
            }
            .chat-top {
              flex: 1;
              margin-left: 16px;
              overflow: hidden;
            }
            .chat-top .user-name{
              color: #595959;
              font-weight: bold;
              font-size: 14px;
            }
            .other{
              font-size: 12px;
              margin-top: 4px;
            }
            .friend-time{
              display: flex;
              align-items: center;
              color: #9A9EBA;
              font-weight: 400;
              line-height: 18px;
            }
            .friend-time-title {
              margin-left: 5px;
            }
              
          .contact-list-info {
            display: flex;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            height: 26px;
            margin-top: -1px;
            -webkit-box-align: center;
            align-items: center;
          }
          .contact-list-info .user-name {
            color: rgb(89, 89, 89);
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            font-size: 14px;
          }
          .contact-list-info .user-label {
            flex:none;
            font-size: 12px;
            margin-left: 4px;
          }
            
          .contact-list-info .com-label {
            border-radius: 4px;
            padding: 0 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #9A9EBA;
            background: #EBECF1;
            line-height: 20px;
            margin-left: 4px;
            flex: none;
          }
          .contact-list-info .com-label-del{
            border-radius: 4px;
            padding: 0 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #F44764;
            background: #FDE3E7;
            line-height: 20px;
            margin-left: 4px;
            flex: none;
          }
          `,
          data: {
            chatMsg: {},
            labels: [],
            createdTime: '',
            ownerName: '',
          },
          methods: {
          },
          error: (err) => {
            console.log('error', err)
          }
        })
        setIsInit(true);
      })
    }
  }, [hasPermission, props.companyNoExpire.corpId, props.companyNoExpire.thirdAgentId, props.agentConfig.thirdsignature, isInit])

    // 改变会话或者当前的消息
    const changeSessionOrMessage = (value) => {
      let instanceChatRefData = {
        chatMsg: value || {},
      };
      
      if (_.isEmpty(value)) {
        instanceChatRefData.labels = [];
        instanceChatRefData.createdTime = '';
        instanceChatRefData.ownerName = '';
      }
      instanceChatRef.current?.setData(instanceChatRefData)
      instanceUserRef.current?.setData({
        chatId: _.get(value, 'sessionId', ''),
      })
      setChatType('1');
      setSearchTime(undefined);
      setSearchContent('');
      setCurrentSession(value);
    };
  
    // 清楚聊天内容
    const resetChatContent = () => {
      paramsRef.current.pageNum = 1;
      listRef.current = [];
      instanceRef.current?.setData({
        showNone: true,
      });
      instanceUpDownRef.current?.setData({
        showNone: true,
      });
      
      instanceChatRef.current?.setData({
        chatMsg: {},
        labels: [],
        createdTime: '',
        ownerName: '',
      });
      // setChatType('1');
      // setSearchTime(undefined);
      // setSearchContent('');
      // setChatSearchCondition(initCondition);
    }
  
    // 查找聊天记录（接口3）
    const chatSearch = () => {
      const { sessionId } = currentSession;
      let params = {
        ...chatSearchCondition,
        sessionId,
        uid: paramsRef.current.uid,
      };
      if (isGroup) {
        params.uid = window?.current_user?.uid || 5536806;
      }
      if (!params.sessionId) {
        resetChatContent();
        return;
      }
      setLoading(true);
      api.chatSearchThird(params).then(async (res) => {
        setLoading(false);
        if (res.code === 0) {
          res.data.msgs = _.get(res.data, 'messageList') || [];
          delete res.data?.messageList;
          let list = res.data.msgs || [];
          list.reverse();
          if (params.pageNum == 1) {
          } else {
            list = res.data.msgs.concat(listRef.current)
          }
          const dateList = resetMessageList(list);
          listRef.current = list;
          instanceRef.current?.setData({
            ...res.data,
            msgs: list,
            dateList: dateList,
            showNone: false
          });
          
          if (params.pageNum == 1) {
            if (!instanceScrollRef.current && instanceRef.current) {
              const wwSDK = window.ww;
              instanceScrollRef.current = await wwSDK.createScrollViewContext(instanceRef.current, 'refName')
            }
            if (_.get(list, 'length')) {
              const id = list[list.length - 1].mgsid;
              setTimeout(() => {
                window.instanceScrollRef = instanceScrollRef.current;
                // instanceScrollRef.current?.scrollTo({ top: 10000000 });
                instanceScrollRef.current?.scrollIntoView(`[data-id=${id}]`,{ block: 'end' });
                setLoading(false);
              }, 2000)
            } else {
              setLoading(false);
            }
            if (instanceChatRef.current) {
              instanceChatRef.current.setData({
                labels: _.get(res.data, 'labels') || [],
                createdTime: _.get(res.data, 'createdTime') ? moment(_.get(res.data, 'createdTime')).format('YYYY年MM月DD日 HH:mm') : '',
                ownerName: _.get(res.data, 'ownerName') || '',
                chatMsg: currentSessionRef.current.item || {},
            })
            }
          } else {
            setLoading(false);
          }
          paramsRef.current.pageNum = params.pageNum;
        } else {
        }
      }).catch(() => {
        setLoading(false);
      });
    };
  
    // 查找聊天记录（接口3） type: down 下一页  up  上一页
    const chatSearchUpDown = (init, type) => {
      const { sessionId } = currentSession;
      let params = {
        ...paramsUpDownRef.current,
      };
      if (!params.sessionId) {
        resetChatContent();
        return;
      }
      if (isGroup) {
        params.uid = window?.current_user?.uid || 5536806;
      }
      setLoading(true);
      api.chatSearchThirdByAgainstConfigId(params).then(async (res) => {
        
        if (res.code === 0) {
          let resData = _.get(res, 'data');
          if (_.isEmpty(resData)) {
            resData = {};
          }
          // {
          //   /*pageType为1表示初始，2表示下拉，3表示向上加载*/
          // }
          resData.msgs = _.get(resData, 'messageList') || [];
          delete resData.messageList;
          resData.msgs = resData.msgs.map(item => {
            return {
              ...item,
              msgIdQuery: 'msg' + item.id,
            };
          })
          let list = resData.msgs || [];
          list.reverse();
          if (init) {
            listRef.current = [];
          }
          let oldList = _.cloneDeep(listRef.current);
          if (init || type == 'up') {
            if (_.isEmpty(list)) {
              if (init) {
                instanceUpDownRef.current?.setData({
                  hasUpPage: false,
                  hasDownPage: false,
                })
              } else {
                instanceUpDownRef.current?.setData({
                  hasUpPage: false,
                })
              }
            }
            list = listRef.current.concat(resData.msgs)
          } else {
            if (_.isEmpty(list)) {
              instanceUpDownRef.current?.setData({
                hasDownPage: false,
              })
            }
            list = resData.msgs.concat(listRef.current)
          }
          const dateList = resetMessageList(list);
          listRef.current = list;
          instanceUpDownRef.current?.setData({
            ...resData,
            msgs: list,
            dateList: dateList,
            showNone: false,
            upPage: params.upPage,
            downPage: params.downPage,
          });
          const msgId =  _.get(resData, 'msgId') ? ('msg' + _.get(resData, 'msgId')) : ''
          if (params.pageNum == 1 || type === 'down') {
            if (!instanceScrollUpDownRef.current && instanceUpDownRef.current) {
              const wwSDK = window.ww;
              instanceScrollUpDownRef.current = await wwSDK.createScrollViewContext(instanceUpDownRef.current, 'refName')
            }
            if (_.get(list, 'length')) {
              if (type === 'down' && _.isEmpty(oldList)) {
                setLoading(false);
                return;
              }
              const id = type === 'down' ? oldList[0].msgIdQuery : (msgId || list[list.length - 1].msgIdQuery);
              instanceScrollUpDownRef.current?.scrollIntoView(`[data-id=${id}]`,{ block: window.blockKey || 'start' });
              setTimeout(() => {
                instanceScrollUpDownRef.current?.scrollIntoView(`[data-id=${id}]`,{ block: 'start' });
                setLoading(false);
              }, 1500)
            } else {
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
          paramsRef.current.pageNum = params.pageNum;
        } else {
          setLoading(false);
        }
      }).catch(() => {
        setLoading(false);
      });
    };

  // 加载更多消息
  const loadMore = () => {
    setChatSearchCondition({
      ...initCondition,
      pageNum: paramsRef.current?.pageNum + 1,
      uid: paramsRef.current.uid
    });
  };
  
  const resetMessageList = (list) => {
    const dateObj = {};
    list?.forEach(item => {
      item.date = moment(item.msgtime).format('YYYY-MM-DD');
      if (!dateObj[item.date]) {
        dateObj[item.date] = [];
      }
      dateObj[item.date].push(item);
      return item
    });
    const dateList = Object.keys(dateObj);
    const newList = dateList.map(date => {
      return {
        date: date,
        list: dateObj[date],
      }
    })
    console.log(dateObj, newList);
    return newList;
  }

  useUpdateEffect(() => {
    console.log('检测到改变重新访问消息')
    if (chatSearchCondition.startTime) {
      const { sessionId } = currentSession;
      paramsUpDownRef.current.startTime = chatSearchCondition.startTime;
      paramsUpDownRef.current.messageType = chatSearchCondition.messageType;
      paramsUpDownRef.current.content = chatSearchCondition.content;
      paramsUpDownRef.current.sessionId = sessionId;
      paramsUpDownRef.current.uid = paramsRef.current.uid;
      paramsUpDownRef.current.upPage = 1;
      paramsUpDownRef.current.downPage = 1;
      paramsUpDownRef.current.pageType = 1;
      paramsUpDownRef.current.pageNum = 1;
      if (searchUpDownTimer.current) clearTimeout(searchUpDownTimer.current);
      searchUpDownTimer.current = setTimeout(() => {
        clearTimeout(searchUpDownTimer.current);
        searchUpDownTimer.current = null;
        chatSearchUpDown(true);
      }, 500)
    } else {
      instanceUpDownRef.current?.setData({
        showNone: true,
      });
      if (searchMessageTimer.current) clearTimeout(searchMessageTimer.current);
      searchMessageTimer.current = setTimeout(() => {
        clearTimeout(searchMessageTimer.current);
        searchMessageTimer.current = null;
        chatSearch();
      }, 1000)
    }
  }, [chatSearchCondition]);

  useUpdateEffect(() => {
    setChatSearchCondition(initCondition);
  }, [currentSession]);


  useEffect(() => {
    if (_.get(currentUser, 'uid')) {
      paramsRef.current.uid = currentUser?.uid;
      if(!_.isEmpty(currentSessionRef.current)) {
        currentSessionRef.current = null;
        instanceUserRef.current?.setData({
          msgList: [],
          activeTab: 1,
          chatId: '',
          item: '',
        })
      }
      resetChatContent()
    } else {
      resetChatContent()
      currentSessionRef.current = null;
      instanceUserRef.current?.setData({
        msgList: [],
        activeTab: 1,
        chatId: '',
        item: '',
      })
    }
  }, [currentUser])

  useEffect(() => {
    let startTime = undefined;
    if (searchTime) {
      const format = 'YYYY-MM-DD'
      startTime = moment(searchTime).format(format) + ' 00:00:00';
    }
    setChatSearchCondition({
      ...initCondition,
      uid: paramsRef.current.uid,
      messageType: chatType,
      content: searchContent,
      startTime,
    });
  }, [chatType, searchContent, searchTime])
  
  return (
    // <Spin spinning={loading}>
    <MainContent>
    {/* style={{height: 440}} */}
        <GlobalStyle />
        <WhiteBackground />
        {hasPermission ? (
          <>
            <ConversationWrapper>
              {
                isInit ? <LeftPart style={{width: isGroup ? 0 : ''}}>
                    <CovSearchUserList {...props} onChange={(user) => setCurrentUser(user)} onSearchMessage={() => {
                      setChatSearchCondition({
                        ...chatSearchCondition,
                        pageNum: 1,
                      });
                    }}/>
                </LeftPart> : null
              }
              
              <CenterPart >
                {
                  isInit ? <CovSearchMessageUserTab {...props} ref={searchMsgRef} currentUser={currentUser} onChange={(obj) => {
                    if(!obj.chatId && _.isEmpty(_.get(currentSessionRef.current, 'chatId'))) return;
                    if (currentSessionTimer.current) clearTimeout(currentSessionTimer.current);
                    currentSessionTimer.current = setTimeout(() => {
                      clearTimeout(currentSessionTimer.current);
                      currentSessionTimer.current = null;
                      if (currentSessionRef.current?.activeTab !== obj.activeTab || (_.isEmpty(currentSessionRef.current?.msgList) && !_.isEmpty(obj.msgList)) || (currentSessionRef.current?.chatId !== obj.chatId)) {
                        changeSessionOrMessage(obj.item);
                        instanceUserRef.current?.setData(obj);
                      }
                      currentSessionRef.current = obj;
                    }, 300)
                    instanceUserRef.current?.setData({
                      msgList: obj.msgList,
                      activeTab: obj.activeTab,
                    })
  
                  }}/> : null
                }
                
                <ContentBox id="conversation-third-user-list"/>
              </CenterPart>
                  <RightPart>
                    <ConversationTitle>
                      <ContentBox id="conversation-third-mes-info" />
                    </ConversationTitle>
                    <CovSearchMessageFilter chatType={chatType} searchTime={searchTime} searchContent={searchContent} onChange={(obj) => {
                      if (_.has(obj, 'searchContent')) {
                        setSearchContent(obj.searchContent);
                      }
                      if (_.has(obj, 'searchTime')) {
                        setSearchTime(obj.searchTime);
                      }
                      if (_.has(obj, 'chatType')) {
                        setChatType(obj.chatType);
                      }
                    }}/>
                    <ConversationContent>
                      <ContentBox style={{ position: 'absolute', zIndex: chatSearchCondition.startTime ? 1 : 2, background: '#fff', height: '100%' }} id="conversation-third-box" />
                      <ContentBox style={{ position: 'absolute', zIndex: chatSearchCondition.startTime ? 2 : 1, background: '#fff', height: '100%' }} id="conversation-third-box-time" />
                    </ConversationContent>
                  </RightPart>
            </ConversationWrapper>
          </>
        ) : (
          <NoPermission />
        )}
    </MainContent>
    // </Spin>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
